import React, { useState } from "react";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import { Box, ListItemText } from "@mui/material";
import { makeStyles } from 'tss-react/mui';
import cloneDeep from "lodash.clonedeep";
import AddIcon from "@mui/icons-material/Add";
import IngredientDialog from "./ingredient-dialog";
import IngredientListItem from "./ingredient-list-item";
import IntentButton, { Intent } from "../input/intent-button";

const useStyles = makeStyles()(() => ({
  newIngredientButton: {
    display: "flex",
    justifyContent: "center",
    margin: "10px auto 0 auto",
    width: "100%",
  },
  noIngredients: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    color: "#999999",
  },
  root: {
    width: "100%",
  },
}));

export default function IngredientList({
  ingredients,
  setIngredients = () => {},
  editMode = false,
  multiplier = 1,
  showCheckBoxes = false,
  handleCheck = null
}: any) {
  const [selectedIngredientIndex, setSelectedIngredientIndex] = useState(null);
  const [ingredientDialogOpen, setIngredientDialogOpen] = useState(false);

  const { classes } = useStyles();

  function removeIngredient(index: any) {
    setSelectedIngredientIndex(null);
    const updateIngredients = cloneDeep(ingredients);
    updateIngredients.splice(index, 1);
    setIngredients(updateIngredients);
  }

  function newIngredient() {
    setSelectedIngredientIndex(null);
    setIngredientDialogOpen(true);
  }

  function updateIngredient(index: any) {
    setSelectedIngredientIndex(index);
    setIngredientDialogOpen(true);
  }

  function ingredientComparator(a: any, b: any) {
    if (!!a.checked === !!b.checked) {
      return a.name.localeCompare(b.name);
    }
    return a.checked ? 1 : -1;
  }

  return (
    <List aria-label="ingredients" className={classes.root}>
      <Divider />
      {ingredients && ingredients.length ? (
        ingredients
          .map((ingredient: any, index: any) => (
            <IngredientListItem
              key={`${ingredient.amount}-${ingredient.unit}-${ingredient.name}`}
              ingredient={ingredient}
              editMode={editMode}
              multiplier={multiplier}
              updateIngredient={() => updateIngredient(index)}
              removeIngredient={() => removeIngredient(index)}
              showCheckBoxes={showCheckBoxes}
              handleCheck={() => handleCheck(index)}
            />
          ))
          .sort((a: any, b: any) =>
            ingredientComparator(a.props.ingredient, b.props.ingredient)
          )
      ) : (
        <ListItem divider>
          <ListItemText
            className={classes.noIngredients}
            primary="No Ingredients"
          />
        </ListItem>
      )}
      {editMode && (
        <Box className={classes.newIngredientButton}>
          <IntentButton
            onClick={() => newIngredient()}
            intent={Intent.PRIMARY}
            startIcon={<AddIcon />}
            variant="contained"
          >
            New Ingredient
          </IntentButton>
        </Box>
      )}
      <IngredientDialog
        open={ingredientDialogOpen}
        handleClose={() => {
          setIngredientDialogOpen(false);
        }}
        editIndex={selectedIngredientIndex}
        ingredients={ingredients}
        setIngredients={setIngredients}
      />
    </List>
  );
}
